import { roundValue, safeParseFloat } from "lib/number";
import { getChildrenUnits } from "./units";
import { getChildrenTotalRetail } from "./total-retail";
import { MergedColumnFormulaOptions } from "./types";
import { MetricsKind } from "../types";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { ValueGetterParams } from "ag-grid-community";

/**
 * This function has dependency of retail and units.
 * `values` is not used here, but it needs to be in the function arg since it inherits signature from other formulas
 * Formula: TOTAL_RETAIL / TOTAL_UNITS
 */
export const AUR = (_values: number[], options: MergedColumnFormulaOptions, gridGetterParams: ValueGetterParams) => {
    const units = referenceMetricValueOrCompute(
        () => getChildrenUnits(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.UNITS
    );
    const totalRetail = referenceMetricValueOrCompute(
        () => getChildrenTotalRetail(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.TOTAL_RETAIL
    );
    const computedValue = safeParseFloat(totalRetail / units, 0);

    return roundValue(computedValue, options.decimal);
};
